import {
  Card,
  CardContent,
  Grid,
  TableCell,
  TableRow,
} from "@mui/material";
import AuditCarrierLogs from "./AuditCarrierLogs";
import AuditHistoryTable from "./AuditHistoryTable";
import { mongoTimeStampToString } from "../../../utils/orders";
import { IOrderAuditInfo } from "../../../interfaces/order";
import WebhookTable from "./WebhookTable";
import OrderDescriptionContent from "../OrderDescriptionContent";

const OrderAuditInfo = ({
  audit: { ordersAudit, carrierAudit, carrierName },
  order
}: IOrderAuditInfo) => (
  <>
    <Grid item xs={12} mb={5}>
      <Card className="br-10 bg-light" sx={{ width: "100%" }}>
        <CardContent sx={{ padding: "20px" }}>
          {order && order.orderInfo && <OrderDescriptionContent {...order} />}
        </CardContent>
      </Card>
    </Grid>

    {ordersAudit?.door_to_door && (
      <AuditHistoryTable
        title="Cambio manual de estado"
        columns={[
          { label: "Fecha y hora" },
          { label: "Usuario" },
          { label: "Acción" },
        ]}
        renderEntries={() => (
          <TableRow>
            <TableCell>
              {mongoTimeStampToString(ordersAudit.door_to_door.changed_at)}
            </TableCell>
            <TableCell>{ordersAudit.door_to_door.changed_by_email}</TableCell>
            <TableCell>{ordersAudit.door_to_door.end_status}</TableCell>
          </TableRow>
        )} />
    )}

    <AuditCarrierLogs
      title="Creación"
      inputValues={carrierAudit.creation.input}
      outputValues={carrierAudit.creation.output} />

    {carrierAudit.cancelation && (
      <AuditCarrierLogs
        title="Cancelación"
        inputValues={carrierAudit.cancelation.input}
        outputValues={carrierAudit.cancelation.output} />
    )}

    <WebhookTable carrierAudit={carrierAudit} carrierName={carrierName} />
  </>
);

export default OrderAuditInfo;
